import { z } from '@hono/zod-openapi';

const googleLatLngSchema = z
  .object({
    lat: z.number().openapi({ description: 'Latitude' }),
    lng: z.number().openapi({ description: 'Longitude' })
  })
  .openapi({ description: 'Latitude/longitude coordinate' });

const googleAddressComponentSchema = z
  .object({
    longName: z
      .string()
      .min(1)
      .openapi({ description: 'Address component long name' }),
    shortName: z
      .string()
      .min(1)
      .openapi({ description: 'Address component short name' }),
    types: z
      .array(z.string().min(1))
      .min(1)
      .openapi({ description: 'Google component types' })
  })
  .openapi({ description: 'Google address component' });

const googleGeometrySchema = z
  .object({
    location: googleLatLngSchema.openapi({
      description: 'Primary geometry location'
    }),
    locationType: z
      .string()
      .optional()
      .openapi({ description: 'location_type value from Google' }),
    viewport: z
      .object({
        northeast: googleLatLngSchema,
        southwest: googleLatLngSchema
      })
      .optional()
      .openapi({ description: 'Suggested viewport bounds' })
  })
  .openapi({ description: 'Google geometry payload' });

export const eventLocationSchema = z
  .object({
    formattedAddress: z
      .string()
      .min(1)
      .openapi({ description: 'Formatted event address' }),
    placeId: z.string().optional().openapi({ description: 'Google place_id' }),
    addressComponents: z
      .array(googleAddressComponentSchema)
      .optional()
      .openapi({ description: 'Address components returned by Google' }),
    geometry: googleGeometrySchema
      .optional()
      .openapi({ description: 'Geometry object returned by Google' })
  })
  .openapi({ description: 'Google geocoding payload' });

export type EventLocation = z.infer<typeof eventLocationSchema>;
